import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import { createSingleRaceFeed } from './stores.js';
import EstimatedVotesRemaining from './components/EstimatedVotesRemaining.svelte';

const RACE_ID = 'CA-6123';

async function main() {
  const element = findElementByIdInShadowDom('estimated-votes-remaining-table');

  if (!element) return;

  const race = await createSingleRaceFeed(RACE_ID);

  renderSvelteComponent(EstimatedVotesRemaining, element, {
    feed: race,
    tableOnly: true,
  });
}

main().catch((error) => {
  console.error('Estimated votes remaining failed:', error);
});
